import { IconProps, iconA11yProps } from '../types';

export const Info = ({ classNames, label }: IconProps) => (
    <svg className={`${classNames}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" {...iconA11yProps(label)}>
        <circle cx="36" cy="36" r="36" className="fill-white" />
        <text x="50%" y="58%" dominantBaseline="middle" textAnchor="middle" className="text-5xl font-bold">
            i
        </text>
    </svg>
);
